import { Flex, Tag, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface PermissionsCardLabelProps {
  title: string
  enabled: number
  total: number
}

export const PermissionsCardLabel = ({
  title,
  enabled,
  total
}: PermissionsCardLabelProps) => {
  return (
    <Flex align="center" gap={10} className={"w-full"}>
      <Text strong className={"capitalize"}>
        {title}
      </Text>
      <Tag>
        {enabled}/{total}
      </Tag>
    </Flex>
  )
}
